import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-[100vh] bg-white grid place-items-center px-6"
    >
      <div className="text-center max-w-xl">
        <div className="overline mb-5">404</div>
        <h1 className="font-display text-5xl md:text-7xl font-black text-slate-900 tracking-tighter leading-none">
          This page <span className="text-[#1D4ED8]">does not exist.</span>
        </h1>
        <p className="mt-6 text-slate-600">
          The page you were looking for has been moved or was never deployed.
        </p>
        <div className="mt-10 flex justify-center">
          <Link to="/" className="btn-primary" data-testid="not-found-home">
            Back to home <ArrowUpRight size={16} weight="bold" />
          </Link>
        </div>
      </div>
    </div>
  );
}
